import React from 'react';

import PriceDisplayRange from '@reverbdotcom/commons/src/components/price_display_range';
import { useUser } from '@reverbdotcom/commons/src/user_hooks';
import { I18N } from '@reverbdotcom/commons/src/components/translate';
import { US } from '@reverbdotcom/commons/src/constants';

import { AveragePriceContainer } from '../../show/price_guide_tool_estimates';

const USD = 'USD';
interface IMoney {
  amountCents?: number;
  currency?: string;
}

interface IProps {
  priceLow: IMoney;
  priceHigh: IMoney;
  priceMiddle: IMoney;
  priceMiddleThirtyDaysAgo: IMoney;
}

export default function PriceEstimates({
  priceLow,
  priceHigh,
  priceMiddle,
  priceMiddleThirtyDaysAgo,
}: IProps) {
  const user = useUser();
  const displayRegionalEstimateCaveat = user.currency != USD || user.countryCode != US;

  return (
    <div className="csp-price-estimates">
      <div className="csp-price-estimates__values">
        <div className="csp-price-estimates__values__display-range">
          <PriceDisplayRange
            moneyLow={priceLow}
            moneyHigh={priceHigh}
            displayConfig={{ precision: 0 }}
          />
        </div>

        <AveragePriceContainer
          hideAveragePriceItemSold={true}
          priceMiddle={priceMiddle}
          priceMiddleThirtyDaysAgo={priceMiddleThirtyDaysAgo}
        />
      </div>

      {displayRegionalEstimateCaveat && (
        <div className="csp-price-estimates__regional-caveat">
          <I18N
            html
            text="discovery.priceGuideTool.show.form.results.regionalEstimateCaveat"
          />
        </div>
      )}
    </div>
  );
}
